// extracted by mini-css-extract-plugin
export default {"diretoria":"Diretoria_diretoria__eC+gn"};